module.exports = __webpack_public_path__ + "img/what-is-api-portal-thumbnail-arrow-tc.f905ba86.jpg";